import React from 'react';

import woman from '../images/woman.svg';
import man from '../images/man.svg';
import neutralGender from '../images/neutralGender.svg';
import Image from './image';

const useUserImg = () => {
  const mapImgToGender = (RelationType, Gender) => {
    const img = <Image src={neutralGender} alt="neutralGender" width="58px" height="58px" />;
    let imgSrc = null;
    if (RelationType === 'D' || RelationType === '9' || RelationType === 'M' || RelationType === 'I') {
      imgSrc = <Image src={woman} alt="Woman" width="58px" height="58px" />;
      imgSrc = Gender ? Gender === 'F' ? imgSrc : img : imgSrc;
    }
    else if (RelationType === 'B' || RelationType === 'F' || RelationType === 'N' || RelationType === 'S') {
      imgSrc = <Image src={man} alt="man" width="58px" height="58px" />;
      imgSrc = Gender ? Gender === 'M' ? imgSrc : img : imgSrc;
    }
    else {
      imgSrc = img;
    }
    return imgSrc;
  };

  return {
    mapImgToGender,
  };

};

export default useUserImg;

